//@flow

import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import { clientSelector } from 'common/redux/selectors/clientSelector';
import invariant from 'common/utils/invariant';
import { Client } from 'common/models/internal/Client';

const useClient = (): Client => {
    const match = useRouteMatch();
    const client = useSelector(state => clientSelector(state, { match }));
    invariant(client, 'Expected client to be present');
    return client;
};

export default useClient;
